import { render } from "./TF2eldrawer.vue?vue&type=template&id=15594ca7&scoped=true"
import script from "./TF2eldrawer.vue?vue&type=script&lang=js"
export * from "./TF2eldrawer.vue?vue&type=script&lang=js"

import "./TF2eldrawer.vue?vue&type=style&index=0&id=15594ca7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15594ca7"]])

export default __exports__